<template>
  <div style="background:#FAFAFA;" class="policeLato">
    <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
    <section v-if="isDesktop()">
      <div class="mt-5 pt-5 paralax-cover-image has-background-dim">
        <p class="paralax-cover-image-text">
        <div class="content_home" style="z-index: 1!important;">
          <h1 style="font-size: 70px" class="font-weight-bold"><span style="color: #fff">Espace</span></h1>
          <h1 style="font-size: 70px;margin-top: -30px" class="font-weight-bold"><span style="color: #ffa409" class="ml-1">Sinistre</span></h1>
        </div>
        </p>
      </div>
    </section>

    <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
    <section class="mt-5" v-if="isMobile()">
      <div class="paralax-cover-image_mobile has-background-dim_mobile">
        <p class="paralax-cover-image-text_mobile">
        <div class="content_home" style="z-index: 1!important;margin-top: 20%">
          <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">Espace</span></h1>
          <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>Sinistre</span></h1>
        </div>
        </p>
      </div>
    </section>

    <div>
      <div class="container" style="background: #FAFAFA">
        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div v-responsive.lg.xl class="mt-5 row" style="background:#FAFAFA" v-if="isDesktop()">
          <div class="col-md-10 offset-1" style="background:#FAFAFA">
            <div class="form" style="background:#FAFAFA">
              <div class="page mb-5">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                    <div>
                      <div class="fields" style="margin-top: 10%;margin-bottom: 10%;">
                        <div class="row mt-5">
                          <div class="col-sm-6">
                            <img width="100%" src="../../assets/img/pouce/done-sinistre.png" alt="sinistre-done">
                          </div>
                          <div class="col-sm-6" style="margin-top: 13%!important">
                            <div class="field-title" style="line-height: 1!important;">
                              <span class="font-weight-bold" style="font-size: 45px;color: green;">Votre sinistre</span> <br>
                              <span class="font-weight-bold" style="font-size: 45px;color: green">est bien déclaré !</span> <br>
                              <span class="ml-3" style="font-size: 15px">Rassurez-vous, nous prenons le relais</span>
                            </div>
                            <div class="wizard-card-footer clearfix mb-5 mr-5">
                              <div class="wizard-footer-left">
                              </div>
                              <div class="wizard-footer-right">
                                <button @click="toHome()" type="button" class="wizard-btn">
                                  Accueil
                                </button>
                                <button @click="toDashboard()" type="button" class="ml-3 wizard-btn">
                                  Espace personnel
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE     ================= -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div v-responsive.sm.xs class="mt-5 row" style="background:#FAFAFA" v-if="isMobile()">
          <div class="col-md-10" style="background:#FAFAFA">
            <div class="form" style="background:#FAFAFA">
              <div class="page mb-5">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                    <div>
                      <div class="fields" style="margin-top: 10%;margin-bottom: 10%;">
                        <div class="row mt-5">
                          <div class="col-sm-6">
                            <img width="100%" src="../../assets/img/pouce/done-sinistre.png" alt="sinistre-done">
                          </div>
                        </div>
                        <div class="justify-content-center row">
                          <div class="col-sm-6">
                            <div class="text-center field-title" style="line-height: 1!important;">
                              <span class="font-weight-bold" style="font-size: 45px;color: green;">Votre sinistre est</span> <br>
                              <span class="font-weight-bold" style="font-size: 45px;color: green">bien déclaré !</span> <br>
                              <span style="font-size: 15px">Rassurez-vous, nous prenons le relais</span>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div class="wizard-card-footer clearfix mb-3 mr-5">
                            <div class="wizard-footer-left">
                            </div>
                            <div class="wizard-footer-right">
                              <button @click="toHome()" type="button" class="wizard-btn">
                                Accueil
                              </button>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div class="wizard-card-footer clearfix mb-5 mr-5">
                            <div class="wizard-footer-left">
                            </div>
                            <div class="wizard-footer-right">
                              <button @click="toDashboard()" type="button" class="wizard-btn">
                                Espace personnel
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
    }
  },
  methods : {
    toHome(){
      this.$router.push('/')
    },

    toDashboard() {
      this.$router.push('/dashboard')
    },

    isMobile: function () {
      if (screen.width <= 760) {
        return true
      } else {
        return false
      }
    },

    isTablette() {
      if (screen.width > 425 && screen.width <= 768) {
        return true
      } else {
        return false
      }
    },

    isDesktop: function () {
      if (screen.width > 768) {
        return true
      } else {
        return false
      }
    },
  },
}
</script>

<style lang="less" scoped>
@import "../../assets/css/button.css";
@import "../../assets/css/devis_css.css";
.borderRadius {
  border-radius: 15px;
  border: 2px solid #ffa409 !important;
}

.selectatDesktop {
  border-radius: 15px;
  background: url(https://) no-repeat right;
  -webkit-appearance: none;
  background-position-x: 680px;
  border: 2px solid lightgrey !important;
}

.selectatMobile {
  border-radius: 15px;
  background: url(https://) no-repeat right;
  -webkit-appearance: none;
  background-position-x: 93%;
  border: 2px solid lightgrey !important;
}

.ListStyle li {
  list-style: none
}

.file-btn {
  color: #ffa409 !important;
  text-transform: lowercase;
}

.border-round {
  border: 1px solid grey;
  border-radius: 10px;
}

.form {
  margin-top: -60px;
}

.format {
  margin-left: -70px;
  width: 300px;
  margin-top: -50px;
}

.premier {
  /* max-width: 1200px; */
  margin: auto;
  margin-top: 100px;
}

.detail {
  color: grey;
  margin-left: 80px;
}

.mobile {
  margin-left: 2px;
  margin-right: 2px;
  margin-bottom: 10px;
}

.dom {
  color: grey;
  margin-right: 0px;
  margin-top: 20px;
}

.file {
  width: 500px;
  margin-bottom: 50px;
  margin-left: 16%;
}

.list-boutons li {
  text-decoration: none !important;
  list-style: none;
}


.list-boutons li .link-btn:hover {
  text-decoration: none !important;
  color: white !important;
}


.assuraf-text-color {
  color: #ffa409;
}


.sinistre {
  margin-left: 150px;
  margin-top: 10px;
  margin-bottom: 50px;


}

/* ==================CSS SINISTRE FORM MOBILE============== */
.border-radius {
  border-radius: 20px !important
}

.georgia {
  font-family: georgia !important;
}
.policeLato {
  font-family: Lato, "Helvetica Neue", Arial, sans-serif
}

.scroll {
  max-height: 450px;
  overflow-y: auto !important;
}






.p-4{
  background: #D8D8D8!important;
  color: black;
  padding: 0.5rem!important;
}
.comment{
  background: white!important;
  width: 100%;
  height: 100px;
  padding: 0;
}

.paralax-cover-image {
  background-image: url('../../assets/img/assurance/sinistre.jpg');
  position: relative;
  background-size: contain!important;
  background-position: 50%;
  min-height: 230px;
  width: 100%;
  margin: 0 0 0;
  display: flex;
  /*padding: 20px;*/
  align-items: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;

}
.paralax-cover-image p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
}

.paralax-cover-image .paralax-cover-image-text,
.paralax-cover-image h2 {
  color: #fff;
  font-size: 2em;
  line-height: 1.25;
  z-index: 1;
  margin-bottom: 0;
  max-width: 610px;
  text-align: center;
  margin-left: 8.5%;
}

.paralax-cover-image.has-background-dim:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.paralax-cover-image {
  background-attachment: fixed;
  background-position: 50% 50px;
}


.paralax-cover-image_mobile {
  background-image: url('../../assets/img/assurance/sinistre_mobile.jpg');
  position: relative;
  background-size: contain;
  background-position: 50%;
  min-height: 150px;
  width: 100%;
  margin: 0 0 0;
  display: flex;
  //padding: 20px;
  align-items: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;

}
.paralax-cover-image_mobile p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
  padding-bottom: 20Px;
}

.paralax-cover-image_mobile .paralax-cover-image-text_mobile,
.paralax-cover-image_mobile h2 {
  color: #fff;
  font-size: 2em;
  line-height: 1.25;
  z-index: 1;
  margin-bottom: 0;
  max-width: 610px;
  text-align: center;
  margin-left: 8.5%;
}

.paralax-cover-image_mobile.has-background-dim_mobile:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.paralax-cover-image_mobile {
  // background-attachment: fixed;
  background-position: 50% 40px;
}


</style>
